import { render, staticRenderFns } from "./creat-text.vue?vue&type=template&id=02367ea9&scoped=true"
import script from "./creat-text.vue?vue&type=script&lang=js"
export * from "./creat-text.vue?vue&type=script&lang=js"
import style0 from "./creat-text.vue?vue&type=style&index=0&id=02367ea9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02367ea9",
  null
  
)

export default component.exports